import { createTheme } from '@mui/material/styles'

export const theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: () => ({
        '& label.Mui-disabled': {
          color: 'rgba(0, 0, 0, 0.38) !important',
        },
        '& .Mui-disabled fieldset': {
          borderColor: 'rgba(0, 0, 0, 0.38) !important',
        },
        '& .Mui-disabled': {
          cursor: 'not-allowed',
          '& *': {
            cursor: 'not-allowed !important',
          },
        },
        button: {
          '&:disabled': {
            cursor: 'not-allowed',
            pointerEvents: 'all !important',
          },
        },
      }),
    },
  },
})
